export class UrlVarService {
    static parsed:{[key:string]:string;} = null;
    static get(key:string):string {
        if (!UrlVarService.parsed) {
            let query:any = window.location.search.substring(1),
                vars:any,
                i:number;
            UrlVarService.parsed = {};
            vars = query.split('&');
            for (i=0; i < vars.length; i++) {
                let pair = vars[i].split('=');
                if (pair[0] !== "") {
                    // Store the keys in lower case so that we can ignore the case when looking them up
                    if (pair.length > 1) {
                        UrlVarService.parsed[decodeURIComponent(pair[0]).toLowerCase()] = decodeURIComponent(pair[1]);
                    }
                    else {
                        UrlVarService.parsed[decodeURIComponent(pair[0]).toLowerCase()] = "";
                    }
                }
            }
        }
        if (key.toLowerCase() in UrlVarService.parsed) {
            return UrlVarService.parsed[key.toLowerCase()];
        }
        return "";
    }
}
